import { render } from "./OrderProductCard.vue?vue&type=template&id=eaee46e8"
import script from "./OrderProductCard.vue?vue&type=script&lang=js"
export * from "./OrderProductCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__